// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input.custom-switch[type=checkbox] {
  position: relative;
  width: 30px;
  height: 12px;
  appearance: none;
  -webkit-appearance: none;
  background: var(--zinc-800);
  outline: none;
  border-radius: 20px;
  box-shadow: inset 0 0 5px var(--zinc-800);
  transition: 0.7s;
}
input.custom-switch[type=checkbox]:before {
  content: "";
  position: absolute;
  width: 21px;
  height: 21px;
  border-radius: 20px;
  top: -0.225rem;
  left: 0;
  background-size: contain;
  box-shadow: 4px 0px 5px 0px rgba(0, 0, 0, 0.302);
  transform: scale(1.1);
  transition: 0.5s;
  cursor: pointer;
}
input.custom-switch:checked[type=checkbox] {
  background: var(--primary);
}
input.custom-switch:checked[type=checkbox]:before {
  left: 12px;
  background-size: contain;
  box-shadow: -4px 0px 5px 0px rgba(0, 0, 0, 0.302);
}
input.custom-switch.secondary-switch[type=checkbox]:before {
  width: 18px;
  height: 18px;
  border-radius: 50em;
  top: -0.185rem;
  background: var(--white);
}
input.custom-switch.secondary-switch:checked[type=checkbox] {
  background: var(--zinc-800);
}
input.custom-switch.secondary-switch:checked[type=checkbox]:before {
  background: var(--orange-400);
}
input.custom-switch.primary-outline-switch[type=checkbox] {
  width: 36px;
  height: 20px;
  background: transparent;
  box-shadow: none;
  border: 1px solid var(--white);
}
input.custom-switch.primary-outline-switch[type=checkbox]:before {
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  border-radius: 50em;
  background: var(--white);
  box-shadow: none;
  transform: scale(1);
}
input.custom-switch.primary-outline-switch:checked[type=checkbox] {
  background: var(--zinc-800);
}
input.custom-switch.primary-outline-switch:checked[type=checkbox]:before {
  left: 17px;
  background: var(--yellow-600);
}`, "",{"version":3,"sources":["webpack://./src/components/ui-kit/SwitchButton/SwitchButton.scss"],"names":[],"mappings":"AAEI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,wBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,yCAAA;EACA,gBAAA;AADN;AAGM;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,OAAA;EACA,wBAAA;EACA,gDAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;AADR;AAKI;EACE,0BAAA;AAHN;AAKM;EACE,UAAA;EACA,wBAAA;EACA,iDAAA;AAHR;AASQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;AAPV;AAWM;EACE,2BAAA;AATR;AAWQ;EACE,6BAAA;AATV;AAcM;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,8BAAA;AAZR;AAaQ;EACE,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;AAXV;AAeM;EACE,2BAAA;AAbR;AAeQ;EACE,UAAA;EACA,6BAAA;AAbV","sourcesContent":["input {\n  &.custom-switch {\n    &[type=\"checkbox\"] {\n      position: relative;\n      width: 30px;\n      height: 12px;\n      appearance: none;\n      -webkit-appearance: none;\n      background: var(--zinc-800);\n      outline: none;\n      border-radius: 20px;\n      box-shadow: inset 0 0 5px var(--zinc-800);\n      transition: 0.7s;\n\n      &:before {\n        content: '';\n        position: absolute;\n        width: 21px;\n        height: 21px;\n        border-radius: 20px;\n        top: -0.225rem;\n        left: 0;\n        background-size: contain;\n        box-shadow: 4px 0px 5px 0px rgba(0, 0, 0, 0.302);\n        transform: scale(1.1);\n        transition: .5s;\n        cursor: pointer;\n      }\n    }\n\n    &:checked[type=\"checkbox\"] {\n      background: var(--primary);\n\n      &:before {\n        left: 12px;\n        background-size: contain;\n        box-shadow: -4px 0px 5px 0px rgba(0, 0, 0, 0.302);\n      }\n    }\n\n    &.secondary-switch {\n      &[type=\"checkbox\"] {\n        &:before {\n          width: 18px;\n          height: 18px;\n          border-radius: 50em;\n          top: -0.185rem;\n          background: var(--white);\n        }\n      }\n\n      &:checked[type=\"checkbox\"] {\n        background: var(--zinc-800);\n\n        &:before {\n          background: var(--orange-400);\n        }\n      }\n    }\n    &.primary-outline-switch {\n      &[type=\"checkbox\"] {\n        width: 36px;\n        height: 20px;\n        background: transparent;\n        box-shadow: none;\n        border: 1px solid var(--white);\n        &:before {\n          top: 2px;\n          left: 2px;\n          width: 14px;\n          height: 14px;\n          border-radius: 50em;\n          background: var(--white);\n          box-shadow: none;\n          transform: scale(1);\n        }\n      }\n\n      &:checked[type=\"checkbox\"] {\n        background: var(--zinc-800);\n\n        &:before {\n          left: 17px;\n          background: var(--yellow-600);\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
